import React from 'react';
import { useTranslation } from 'react-i18next';
import DynamicCrudPage from '../../../components/DynamicCrudPage';
import { usePricingMethods, useCompanies } from '../../../hooks';
import AddIcon from '@mui/icons-material/Add';

const PricingMethodsPage = () => {
  const { t } = useTranslation();

  return (
    <DynamicCrudPage
      entityType="pricingMethods"
      hook={usePricingMethods}
      additionalHooks={{
        companies: useCompanies,
      }}
      addButtonTextKey="table.actions.addPricingMethod"
      addButtonIcon={<AddIcon />}
      entityTypeForDataTable="pricingMethod"
    />
  );
};

export default PricingMethodsPage; 